var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackFlourish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 34.0625,
    height: 40.865,
    viewBox: "0 0 34.0625 40.865",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7553 36.3812C21.7553 38.8911 23.0072 40.865 26.6613 40.865C31.0344 40.865 34.0625 37.6319 34.0625 32.8843C34.0625 26.9626 23.1425 22.1384 17.3485 20.4368C23.1425 18.7267 34.0625 13.9025 34.0625 7.98081C34.0625 3.22473 31.0344 0.000121444 26.6613 0.000121062C23.0072 0.000120742 21.7553 1.97402 21.7553 4.48394C21.7553 6.99386 22.5589 8.43174 24.2506 8.43174C26.0354 8.43174 26.8389 7.26612 29.3342 7.26612C31.3812 7.26612 31.8041 9.48676 30.7637 11.0608C27.3211 16.2508 7.68035 19.9603 2.68198e-06 20.4368C7.67189 20.9133 27.3211 24.6228 30.7637 29.8128C31.8041 31.3783 31.3812 33.6075 29.3342 33.6075C26.8389 33.6075 26.0354 32.4419 24.2506 32.4419C22.4659 32.4419 21.7553 33.9648 21.7553 36.3897",
    fill: "#D6AF66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackFlourish);
export default __webpack_public_path__ + "static/media/back-flourish.bccd4a423537b5b66c068451589ac3c6.svg";
export { ForwardRef as ReactComponent };